class TransitionPromise {
  constructor(config = {}) {
    var _a;
    this.queuedPromises = {
      start: [],
      end: [],
    };
    this.handleTransitionStart = (event) => {
      var _a;
      if (!this.strict || event.target === event.currentTarget) {
        while (this.queuedPromises.start.length > 0) {
          (_a = this.queuedPromises.start.shift()) === null || _a === void 0 ? void 0 : _a('Transition started');
        }
      }
    };
    this.handleTransitionEnd = (event) => {
      var _a;
      if (!this.strict || event.target === event.currentTarget) {
        while (this.queuedPromises.end.length > 0) {
          (_a = this.queuedPromises.end.shift()) === null || _a === void 0 ? void 0 : _a('Transition ended');
        }
      }
    };
    this.start = () => {
      return new Promise((resolve, reject) => {
        this.queuedPromises.start.push(resolve);
        if (this.timeout !== undefined) {
          setTimeout(reject, this.timeout);
        }
      });
    };
    this.end = () => {
      return new Promise((resolve, reject) => {
        this.queuedPromises.end.push(resolve);
        if (this.timeout !== undefined) {
          setTimeout(reject, this.timeout);
        }
      });
    };
    this.strict = (_a = config.strict) !== null && _a !== void 0 ? _a : true;
    this.timeout = config.timeout;
    if (config.element) {
      this.el = config.element;
      config.element.addEventListener('transitionstart', this.handleTransitionStart);
      config.element.addEventListener('transitionend', this.handleTransitionEnd);
    }
  }
}

export { TransitionPromise as T };
